<template>
  <div>
  </div>
</template>
<script>
export default {
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
  },
  mounted() {
    this.redirect();
  },
  methods: {
    redirect(){
      if(this.user !== null){
      this.$router.push({
          name: "myprofile",
          params: { action: 'delete_account' },
        });
      } else {
        this.$router.push({
          name: "login",
          params: { action: 'delete_account' },
        });
      }
    }
  }
}
</script>